// extracted by mini-css-extract-plugin
export default {"mapContainer":"LiveMap_mapContainer__zjVbE","idle":"LiveMap_idle__r71+O"};